import React from "react";
import { AppSpinner } from "./AppSpinner";

interface Props {
  isLoading: boolean;
  children?: React.ReactNode;
}

export const SpinnerWrapper: React.FunctionComponent<Props> = ({ isLoading, children }) => {
  return isLoading ? <AppSpinner /> : <>{children}</>;
};
